import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  dialog: {
    width: 400,
    height: 441,
    borderRadius: 16,
    padding: '16px 32px 32px 32px',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  dialogContent: {
    padding: '32px 16px',
  },
}));
